/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetWebhookGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type GetWebhookRequest = {
  webhookID: string;
};

export type GetWebhookResponse = {
  headers: { [k: string]: Array<string> };
  result: components.Webhook;
};

/** @internal */
export const GetWebhookGlobals$inboundSchema: z.ZodType<
  GetWebhookGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type GetWebhookGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const GetWebhookGlobals$outboundSchema: z.ZodType<
  GetWebhookGlobals$Outbound,
  z.ZodTypeDef,
  GetWebhookGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function getWebhookGlobalsToJSON(
  getWebhookGlobals: GetWebhookGlobals,
): string {
  return JSON.stringify(
    GetWebhookGlobals$outboundSchema.parse(getWebhookGlobals),
  );
}
export function getWebhookGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<GetWebhookGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetWebhookGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetWebhookGlobals' from JSON`,
  );
}

/** @internal */
export const GetWebhookRequest$inboundSchema: z.ZodType<
  GetWebhookRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  webhookID: z.string(),
});
/** @internal */
export type GetWebhookRequest$Outbound = {
  webhookID: string;
};

/** @internal */
export const GetWebhookRequest$outboundSchema: z.ZodType<
  GetWebhookRequest$Outbound,
  z.ZodTypeDef,
  GetWebhookRequest
> = z.object({
  webhookID: z.string(),
});

export function getWebhookRequestToJSON(
  getWebhookRequest: GetWebhookRequest,
): string {
  return JSON.stringify(
    GetWebhookRequest$outboundSchema.parse(getWebhookRequest),
  );
}
export function getWebhookRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetWebhookRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetWebhookRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetWebhookRequest' from JSON`,
  );
}

/** @internal */
export const GetWebhookResponse$inboundSchema: z.ZodType<
  GetWebhookResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.Webhook$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type GetWebhookResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.Webhook$Outbound;
};

/** @internal */
export const GetWebhookResponse$outboundSchema: z.ZodType<
  GetWebhookResponse$Outbound,
  z.ZodTypeDef,
  GetWebhookResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.Webhook$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function getWebhookResponseToJSON(
  getWebhookResponse: GetWebhookResponse,
): string {
  return JSON.stringify(
    GetWebhookResponse$outboundSchema.parse(getWebhookResponse),
  );
}
export function getWebhookResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetWebhookResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetWebhookResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetWebhookResponse' from JSON`,
  );
}
